import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      overflowX: "auto",
      width: "100%",
      borderCollapse: "collapse",
      borderBottom: 0,
      borderRadius: "4px",
      "& .MuiTableHead-root .MuiTableCell-root:first-child": {
        borderTopLeftRadius: "4px",
        backgroundColor: "#eeeeee",
        paddingLeft: "1rem"
        // width: "50px"
      },
      "& .MuiTableRow-root:before": {
        display: "none"
      },
      "& .MuiTableRow-root:hover": {
        backgroundColor: "#ffffff!important"
      },
      "& .MuiTableRow-root:nth-child(even)": {
        backgroundColor: "#ffffff"
      },
      "& .MuiTableHead-root .MuiTableCell-root:last-child": {
        borderTopRightRadius: "4px",
        backgroundColor: "#fff3f6",
        paddingRight: "1rem",
        width: "500px"
      },
      "& .MuiTableBody-root .MuiTableCell-root:first-child": {
        paddingLeft: "1rem"
      },
      "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root:first-child": {
        borderBottomLeftRadius: "4px"
      },
      "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root:last-child": {
        borderBottomRightRadius: "4px"
      },
      "& .MuiTableCell-head": {
        backgroundColor: "#fff",
        borderBottomWidth: "0!important",
        "& *": {
          color: theme.palette.grey[900]
        }
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableCell-root": {
        padding: "0.5rem 1rem",
        border: "1px solid #E0E0E0",
        color: theme.palette.grey[900],
        height: "auto",
        "& span": {
          // color: theme.palette.grey[900]
        }
      }
    },
    colLine: {
      backgroundColor: "#eeeeee"
    },
    colRemarks: {
      backgroundColor: "#fff3f6"
    },
    col100: {
      width: 100,
      color: theme.palette.grey[900]
    },
    col120: {
      width: 120,
      color: theme.palette.grey[900]
    },
    col160: {
      width: 160,
      color: theme.palette.grey[900]
    },
    colMin160: {
      textWrap: "nowrap",
      minWidth: 160,
      color: theme.palette.grey[900]
    },
    col170: {
      width: 170,
      color: theme.palette.grey[900]
    },
    col180: {
      width: 180,
      color: theme.palette.grey[900]
    },
    col340: {
      width: 340,
      color: theme.palette.grey[900]
    },
    itemNo: {
      textAlign: "left"
    },
    flip: {
      transform: "rotate(180deg) scaleX(-1)"
    },
    estDate: {
      color: "#222222"
    },
    estDateNotMatch: {
      color: `${theme.palette.error.light} !important`
    },
    colQty: {
      marginRight: 55
    },
    colQtyRight: {
      display: "inline-block",
      width: 35,
      textAlign: "right",
      marginLeft: 27
    },
    colQtyLeft: {
      minWidth: 50,
      display: "inline-block"
    },
    colQtyRite: {
      minWidth: 50,
      display: "inline-block",
      marginLeft: 30,
      textAlign: "left"
    },
    pagination: {
      background: "rgba(212, 244, 248, 0.8)"
    },
    decimalFormat: {
      color: theme.palette.grey[500]
    },
    paginateFooter: {
      marginTop: 16
    },
    rowClickable: {
      cursor: "pointer"
    }
  }),
  { name: "TableUploadFail" }
);
export default useStyles;
